import { useCallback } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  ActionButton,
  ActionLink,
  FloatingBox,
  IconComponent,
  IconName,
} from "@hopper-b2b/ui";
import { Box, Container, Typography } from "@material-ui/core";
import RedErrorIcon from "../../assets/client/red-error-exclamation.svg?react";
import { closeNubankWebview } from "../../utils/nubankHandoff";
import styles from "./Maintenance.module.scss";

export const Maintenance = () => {
  const { t } = useI18nContext();

  const handleClose = useCallback(() => {
    closeNubankWebview();
  }, []);

  return (
    <Container maxWidth="md" className={styles.fullHeight}>
      <Box className={styles.fullHeight}>
        <Box textAlign="start" px={3} py={2}>
          <ActionLink
            content={
              <IconComponent
                ariaLabel={t("closeModal")}
                name={IconName.Close}
                className={styles.closeIcon}
              />
            }
            onClick={handleClose}
          />
        </Box>
        <Box textAlign="start" px={3} py={1}>
          <RedErrorIcon className={styles.errorIcon} />
        </Box>
        <Box textAlign="start" px={3} py={1.5}>
          <Typography className={styles.text} variant="h3" gutterBottom>
            {t("maintenance.title")}
          </Typography>
          <Typography className={styles.description}>
            {t("maintenance.subtitle")}
          </Typography>
        </Box>
      </Box>
      <FloatingBox>
        <ActionButton
          message={t("maintenance.cta")}
          onClick={handleClose}
          className={styles.maintenanceButton}
        />
      </FloatingBox>
    </Container>
  );
};
